// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"379":"d46c8b8239526675","538":"a0f23cc5a709a9ee","983":"b49f2136992ee952"}[chunkId] + ".js";
};